import { render, staticRenderFns } from "./ModelStatus.vue?vue&type=template&id=b121430c&"
import script from "./ModelStatus.vue?vue&type=script&lang=js&"
export * from "./ModelStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports